/**
 * Created by Анжелика on 31.08.2017.
 */
import React, {Component} from 'react';
import {Link} from 'react-router';
import PropTypes from 'prop-types';
import * as strings from '../constants/strings';
import GenreList from '../containers/GenreList';
import SettingList from './SettingList';

class Menu extends Component {

    constructor(props) {
        super(props);
        this.state = {
            menuActive: "genres",
            itemActive: ""
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.doCollapse){
            this.setState({menuActive: null});
        }
    }

    menuClick(e, tag) {
        e.preventDefault();
        e.stopPropagation();
        if (this.state.menuActive === tag) {
            this.setState({menuActive: null})
        } else {
            this.setState({menuActive: tag});
        }
    }

    itemClick(item) {
        const {menuActive} = this.state;
        switch (menuActive) {
            case "genres":
                const genre = item;
                this.setState({itemActive: genre.id});
                break;

            case "settings":
                this.setState({itemActive: item});
                break;

            default:
                break;
        }
    }

    render() {
        const {onLogoutClick} = this.props;
        return (
            <ul className="menu">
                <li className={this.state.menuActive === 'genres' ? 'active' : ''}>
                    <a href="" onClick={(e) => this.menuClick(e,"genres")}>{strings.STR_MENU_GENRES}</a>
                    <GenreList itemActive={this.state.itemActive} onItemClick={this.itemClick.bind(this)} />
                </li>
                <li className={this.state.menuActive === 'settings' ? 'active' : ''}>
                    <a href="" onClick={(e) => this.menuClick(e,"settings")}>{strings.STR_MENU_SETTINGS}</a>
                    <SettingList itemActive={this.state.itemActive} onItemClick={this.itemClick.bind(this)} />
                </li>
                <li>
                    <Link to={'/'} onClick={onLogoutClick}>{strings.STR_MENU_EXIT}</Link>
                </li>
            </ul>
        )
    }
}

Menu.propTypes = {
    onLogoutClick: PropTypes.func.isRequired
};

export default Menu;



// WEBPACK FOOTER //
// ./src/components/Menu.js